// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__8JYXZ","redes":"Footer_redes__0CupN","footer1":"Footer_footer1__zd0iB","bandeiras":"Footer_bandeiras__UOnmi"};